// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3B4KA","video":"styles_video__2pcDy","title":"styles_title__3Iy55"};